import { STATUS_LABELS } from '../constants/status';

// What to show for an endpoint: inside an active maintenance window it reads
// as "maintenance" rather than whatever its checks happen to say.
export function getDisplayStatus(endpoint) {
  if (endpoint?.in_maintenance) return 'maintenance';
  return endpoint?.latest?.status || 'unknown';
}

export function getOverallStatus(allEndpoints = []) {
  // Members of a composite service are already represented by their parent;
  // counting both would let one dead host look like a site-wide outage.
  const topLevel = allEndpoints.filter((ep) => !ep.parent_id);
  if (topLevel.length === 0) return 'All Systems Operational';

  // Planned work isn't an outage: leave maintained endpoints out of the count.
  const endpoints = topLevel.filter((ep) => !ep.in_maintenance);
  const inMaintenance = endpoints.length < topLevel.length;
  if (endpoints.length === 0) return 'Scheduled Maintenance';

  const downCount = endpoints.filter((ep) => ep.latest?.status === 'down').length;
  const total = endpoints.length;

  if (downCount === 0) {
    if (endpoints.some((ep) => ep.latest?.status !== 'up')) return 'Degraded Performance';
    return inMaintenance ? 'Scheduled Maintenance' : 'All Systems Operational';
  }

  if (downCount === total) return 'Complete Outage';
  if (downCount / total > 0.5) return 'Major Outage';
  return 'Minor Outage';
}

export function isMaintenanceActive(window, now = new Date()) {
  if (!window) return false;
  if (window.status === 'cancelled' || window.status === 'completed') return false;
  if (window.status === 'in_progress') return true;
  return new Date(window.start_time) <= now && new Date(window.end_time) >= now;
}

export function getStatusClass(status) {
  if (status === 'up') return 'status-up';
  if (status === 'down') return 'status-down';
  if (status === 'degraded') return 'status-degraded';
  if (status === 'maintenance') return 'status-maintenance';
  return 'status-degraded';
}

export function getStatusLabel(status) {
  return STATUS_LABELS[status] || STATUS_LABELS.unknown;
}

export function getUptimeColorValue(pct) {
  if (pct === null || pct === undefined) return 'var(--text-tertiary)';
  if (pct >= 99) return 'var(--status-up)';
  if (pct >= 95) return 'var(--status-degraded)';
  return 'var(--status-down)';
}

export function formatUptimePercent(pct, decimals = 1) {
  if (pct === null || pct === undefined) return null;
  if (pct % 1 === 0) return `${pct}%`;
  return `${parseFloat(Number(pct).toFixed(decimals))}%`;
}
